import { toggleAllSelection } from 'app/multi-select/actions';
import { getSelectAll } from 'app/multi-select/selectors';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { bindAction } from '../../../common/utils/actions';
import type { MultiSelectSlice } from '../../slice';
import SelectAllCell from './select-all-cell';

function mapStateToProps(state: MultiSelectSlice, { tableName }: { tableName: string }): { selectAll: string } {
  return {
    selectAll: getSelectAll(state, { multiSelectName: tableName })
  };
}

function mapDispatchToProps(
  dispatch: Dispatch,
  props: { tableName: string }
): { toggleAllSelection: ReturnType<typeof toggleAllSelection> } {
  return {
    toggleAllSelection: bindAction(toggleAllSelection, { multiSelectName: props.tableName }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectAllCell);
